// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1VfsC","detailsBorder":"styles_detailsBorder__C0hlO"};